import * as React from "react"

const CapsuleMarkIcon = ({ className, width, height }) => {
  return (
    <svg
      fill="none"
      className={className}
      height={height}
      width={width}
      viewBox="0 0 72 72"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m0 0h72v72h-72z" fill="#fff" />
      <g fill="#1f2e5c">
        <path d="m4.33008 55.2582h7.96052v-4.9919h10.157v4.9919h7.9605v-38.3825h-26.07802z" />
        <path d="m44.3427 6.17891c-1.2032 0-2.1825.97879-2.1825 2.1813s.9793 2.18129 2.1825 2.18129c1.2031 0 2.1825-.97878 2.1825-2.18129s-.9794-2.1813-2.1825-2.1813z" />
        <path d="m44.3427 16.2325c-1.2032 0-2.1825.9788-2.1825 2.1813s.9793 2.1813 2.1825 2.1813c1.2031 0 2.1825-.9788 2.1825-2.1813s-.9794-2.1813-2.1825-2.1813z" />
        <path d="m44.3427 26.286c-1.2032 0-2.1825.9788-2.1825 2.1813s.9793 2.1813 2.1825 2.1813c1.2031 0 2.1825-.9788 2.1825-2.1813s-.9794-2.1813-2.1825-2.1813z" />
        <path d="m54.5985 6.17891c-1.2032 0-2.1825.97879-2.1825 2.1813s.9793 2.18129 2.1825 2.18129 2.1825-.97878 2.1825-2.18129-.9793-2.1813-2.1825-2.1813z" />
        <path d="m54.5985 16.2325c-1.2032 0-2.1825.9788-2.1825 2.1813s.9793 2.1813 2.1825 2.1813 2.1825-.9788 2.1825-2.1813-.9793-2.1813-2.1825-2.1813z" />
        <path d="m54.5985 26.286c-1.2032 0-2.1825.9788-2.1825 2.1813s.9793 2.1813 2.1825 2.1813 2.1825-.9788 2.1825-2.1813-.9793-2.1813-2.1825-2.1813z" />
        <path d="m64.6708 6.17891c-1.2032 0-2.1825.97879-2.1825 2.1813s.9793 2.18129 2.1825 2.18129 2.1825-.97878 2.1825-2.18129c.014-1.20251-.9653-2.1813-2.1825-2.1813z" />
        <path d="m64.6708 16.2325c-1.2032 0-2.1825.9788-2.1825 2.1813s.9793 2.1813 2.1825 2.1813 2.1825-.9788 2.1825-2.1813c.014-1.2025-.9653-2.1813-2.1825-2.1813z" />
        <path d="m64.6708 26.286c-1.2032 0-2.1825.9788-2.1825 2.1813s.9793 2.1813 2.1825 2.1813 2.1825-.9788 2.1825-2.1813-.9654-2.1813-2.1825-2.1813z" />
      </g>
      <path
        d="m17.6613 41.9047c-7.205-.1678-13.19293 5.5372-13.36081 12.7382-.16789 7.2011 5.54019 13.1857 12.74521 13.3535 7.2051.1678 13.193-5.5372 13.3608-12.7382.1819-7.2011-5.5262-13.1857-12.7452-13.3535zm4.0572 17.7161h-8.73v-8.7252h8.73z"
        fill="#e02179"
      />
      <path
        d="m30.4033 17.6525c.1685-7.2029-5.5372-13.17865-12.744-13.34725-7.2068-.16861-13.18566 5.53379-13.35418 12.73665-.16851 7.2029 5.53716 13.1786 12.74398 13.3472 7.2068.1686 13.1857-5.5338 13.3542-12.7366z"
        fill="#42bb9c"
      />
      <path
        d="m41.0957 39.4297v26.8888h26.9035v-26.8888zm21.4333 19.5059h-15.9631v-3.3279h15.9631zm0-8.8091h-15.9631v-3.3279h15.9631z"
        fill="#42bb9c"
      />
    </svg>
  )
}

export default CapsuleMarkIcon
